import { PillSkeleton, TextSkeleton } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { ShiftCardWrapper } from "../../Shift/Card/Wrapper";
import { VisitCardContentWrapper } from "../Card/ContentWrapper";

function VisitOccurrencesListCardSkeleton() {
  return (
    <ShiftCardWrapper sx={{ width: "100%", minHeight: "auto" }}>
      <VisitCardContentWrapper>
        <PillSkeleton />
        <TextSkeleton variant="body1" width="100%" />
        <TextSkeleton variant="body1" width="100%" />
      </VisitCardContentWrapper>
    </ShiftCardWrapper>
  );
}

export function VisitOccurrencesListSkeleton() {
  return (
    <Stack sx={{ overflowY: "auto", width: "100%" }} spacing={5} p={5}>
      <TextSkeleton variant="h3" width="100%" />
      <TextSkeleton variant="body2" width="100%" />
      <VisitOccurrencesListCardSkeleton />
      <VisitOccurrencesListCardSkeleton />
      <VisitOccurrencesListCardSkeleton />
    </Stack>
  );
}
